<template>

	<section class="container" v-if="stats">

		<header class="container__header">

			<h1>Stats</h1>

		<!--	<router-link class="btn btn&#45;&#45;md btn&#45;&#45;primary primary&#45;&#45;copper margin-t-50"  :to="{name:'product.create'}">Tilføj nyt produkt</router-link>
-->
		</header>

		<section class="container__body container__body--lg">

			<header class="col-12 margin-b-50 flex--space">

				<h1>Data</h1>

				<section class="datepicker">

					<a href="#" @click.prevent="showDatePickerModal = true"><i class="icon--md fas fa-calendar-alt"></i> {{dateRangeText}}</a>

				</section>

			</header>

			<main class="stats">

				<section class="item">

					<h1>
						<animate-number
							:from="old_total_revenue"
							:to="stripeAmount(stats.total_revenue).amountForEditing"
							duration="2000"
							easing="easeInOutCirc"
							mode="manual"
							ref="totalRevenue">
						</animate-number><span>kr</span>
					</h1>

					<h2>Total omsætning</h2>

					<p>Den totale omsætning i shoppen i den <br>valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1>
						<animate-number
								:from="old_average_revenue"
								:to="stripeAmount(stats.average_revenue).amountForEditing"
								duration="2000"
								easing="easeInOutCirc"
								mode="manual"
								ref="averageRevenue">
						</animate-number><span>kr</span>
					</h1>

					<h2>Gns. omsætning pr. ordre</h2>

					<p>Den gns. omsætning i shoppen i den <br>valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1>
						<animate-number
								:from="old_total_revenue_without_extra"
								:to="stripeAmount(stats.total_revenue_without_extra).amountForEditing"
								duration="2000"
								easing="easeInOutCirc"
								mode="manual"
								ref="totalRevenueWithoutExtra">
						</animate-number><span>kr</span>
					</h1>

					<h2>Total omsætning uden tilkøb</h2>

					<p>Den totale omsætning uden tilkøb i den <br>valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1>
						<animate-number
								:from="old_total_extras_revenue"
								:to="stripeAmount(stats.total_extras_revenue).amountForEditing"
								duration="2000"
								easing="easeInOutCirc"
								mode="manual"
								ref="totalExtrasRevenue">
						</animate-number><span>kr</span>
					</h1>

					<h2>Total omsætning for tilkøb</h2>

					<p>Den totale omsætning for tilkøb i den <br>valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1>
						<animate-number
								:from="old_total_revenue_with_delivery"
								:to="stripeAmount(stats.total_revenue_with_delivery).amountForEditing"
								duration="2000"
								easing="easeInOutCirc"
								mode="manual"
								ref="totalRevenueWithDelivery">
						</animate-number><span>kr</span>
					</h1>

					<h2>Total omsætning med levering</h2>

					<p>Den totale omsætning med levering i den <br>valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1>
						<animate-number
								:from="old_total_delivery_fee"
								:to="stripeAmount(stats.total_delivery_fee).amountForEditing"
								duration="2000"
								easing="easeInOutCirc"
								mode="manual"
								ref="totalDeliveryFee">
						</animate-number><span>kr</span>
					</h1>

					<h2>Total omsætning for levering</h2>

					<p>Den totale omsætning for levering i den <br>valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1>
						<animate-number
								:from="old_total_number_of_orders"
								:to="stats.total_number_of_orders"
								duration="2000"
								easing="easeInOutCirc"
								mode="manual"
								ref="totalNumberOfOrders">
						</animate-number><span>stk</span>
					</h1>

					<h2>Totale antal ordre</h2>

					<p>Det totale antal ordre i den <br>valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1>
						<animate-number
								:from="old_total_quantities"
								:to="stats.total_quantities"
								duration="2000"
								easing="easeInOutCirc"
								mode="manual"
								ref="totalQuantities">
						</animate-number><span>stk</span>
					</h1>

					<h2>Totale antal kuverter</h2>

					<p>Det totale antal kuverter i den <br>valgte tidsperiode.</p>

				</section>

			</main>

		</section>

		<ws-modal v-model="showDatePickerModal">

			<section class="modal-wrap">

				<section class="modal--sm center">

					<span class="close" @click.prevent="datePickerReset"><i class="fas fa-times"></i></span>

					<section class="datepicker-trigger"   id="datepicker-trigger">
						<AirbnbStyleDatepicker
								:trigger-element-id="'datepicker-trigger'"
								:inline="true"
								:mode="'range'"
								:date-one="dateStartForDatePicker"
								:date-two="dateEndForDatePicker"
								:showActionButtons="false"
								:monthsToShow="1"
								@date-one-selected="setStartDate"
								@date-two-selected="setEndDate"
						/>
					</section>

				</section>

			</section>

		</ws-modal>

	</section>
</template>

<script>
    import {format} from 'date-fns';
    import da from 'date-fns/locale/da';
    import moment from 'moment';
    export default {
        name: "overall-stats",
		data(){
            return {
				stats:null,
                old_total_revenue:0,
                old_average_revenue:0,
                old_total_revenue_with_delivery:0,
                old_total_revenue_without_extra:0,
                old_total_number_of_orders:0,
                old_total_extras_revenue:0,
                old_total_delivery_fee:0,
                old_total_quantities:0,
				format,
                showDatePickerModal:false,
                dateStartForDatePicker:'',
                dateEndForDatePicker:'',
                dateStart:'',
                dateEnd:'',
			};
		},
        computed:{
            dateRangeText(){
                if(this.dateStart === '' && this.dateEnd === ''){
                    return 'Vælg datoer'
                }
                let startDate = this.format(this.dateStart, 'MMMM DD, YYYY', {locale:da});
                let endDate = this.format(this.dateEnd, 'MMMM DD, YYYY', {locale:da})
                return startDate.charAt(0).toUpperCase() + startDate.slice(1) + ' - ' + endDate.charAt(0).toUpperCase() + endDate.slice(1);
            },
        },
		methods:{
            getStats(){
                axios.get('/api/admin/stats').then(response => {
                    this.stats = response.data.data;
                    setTimeout(()=>{
                        this.$refs.totalRevenue.start();
                        this.$refs.averageRevenue.start();
                        this.$refs.totalRevenueWithoutExtra.start();
                        this.$refs.totalRevenueWithDelivery.start();
                        this.$refs.totalNumberOfOrders.start();
                        this.$refs.totalExtrasRevenue.start();
                        this.$refs.totalDeliveryFee.start();
                        this.$refs.totalQuantities.start();
                    }, 500);
                })
			},
			getStatsByRange(){
                axios.post('/api/admin/stats', {
                    start: this.dateStart,
                    end: this.dateEnd,
                }).then(response => {
                    this.old_total_revenue = this.stats.total_revenue;
                    this.old_average_revenue = this.stats.average_revenue;
                    this.old_total_revenue_without_extra = this.stats.total_revenue_without_extra;
                    this.old_total_revenue_with_delivery = this.stats.total_revenue_with_delivery;
                    this.old_total_number_of_orders = this.stats.total_number_of_orders;
                    this.old_total_extras_revenue = this.stats.total_extras_revenue;
                    this.old_total_delivery_fee = this.stats.total_delivery_fee;
                    this.old_total_quantities = this.stats.total_quantities;

                    this.stats = response.data.data;
                    setTimeout(()=>{
                        this.$refs.totalRevenue.reset(this.stripeAmount(this.old_total_revenue).amountForEditing, this.stripeAmount(this.stats.total_revenue).amountForEditing);
                        this.$refs.averageRevenue.reset(this.stripeAmount(this.old_average_revenue).amountForEditing, this.stripeAmount(this.stats.average_revenue).amountForEditing);
                        this.$refs.totalRevenueWithoutExtra.reset(this.stripeAmount(this.old_total_revenue_without_extra).amountForEditing, this.stripeAmount(this.stats.total_revenue_without_extra).amountForEditing);
                        this.$refs.totalRevenueWithDelivery.reset(this.stripeAmount(this.old_total_revenue_with_delivery).amountForEditing, this.stripeAmount(this.stats.total_revenue_with_delivery).amountForEditing);
                        this.$refs.totalNumberOfOrders.reset(this.old_total_number_of_orders, this.stats.total_number_of_orders);
                        this.$refs.totalExtrasRevenue.reset(this.stripeAmount(this.old_total_extras_revenue).amountForEditing, this.stripeAmount(this.stats.total_extras_revenue).amountForEditing);
                        this.$refs.totalDeliveryFee.reset(this.stripeAmount(this.old_total_delivery_fee).amountForEditing, this.stripeAmount(this.stats.total_delivery_fee).amountForEditing);
                        this.$refs.totalQuantities.reset(this.old_total_quantities, this.stats.total_quantities);

                        this.$refs.totalRevenue.start();
                        this.$refs.averageRevenue.start();
                        this.$refs.totalRevenueWithoutExtra.start();
                        this.$refs.totalRevenueWithDelivery.start();
                        this.$refs.totalNumberOfOrders.start();
                        this.$refs.totalExtrasRevenue.start();
                        this.$refs.totalDeliveryFee.start();
                        this.$refs.totalQuantities.start();
                    }, 500);
                })
			},
            setStartDate(val){
                this.dateStartForDatePicker = val;
            },
            setEndDate(val){
                this.dateStart = this.dateStartForDatePicker;
                this.dateEnd = val;
                this.getStatsByRange();
                this.datePickerReset()
            },
            datePickerReset(){
                this.showDatePickerModal = false;
                this.dateStartForDatePicker = '';
                this.dateEndForDatePicker = '';
            },
            getStatsFromLastMonth(){
                const startDate = moment().startOf('month');
                const endDate = moment().endOf('month');

                this.dateStart = startDate.format('YYYY-MM-DD');
                this.dateEnd = endDate.format('YYYY-MM-DD');

                axios.post('/api/admin/stats', {
                    start: this.dateStart,
                    end: this.dateEnd,
                }).then(response => {
                    this.stats = response.data.data;
                    setTimeout(()=>{
                        this.$refs.totalRevenue.start();
                        this.$refs.averageRevenue.start();
                        this.$refs.totalRevenueWithoutExtra.start();
                        this.$refs.totalRevenueWithDelivery.start();
                        this.$refs.totalNumberOfOrders.start();
                        this.$refs.totalExtrasRevenue.start();
                        this.$refs.totalDeliveryFee.start();
                        this.$refs.totalQuantities.start();
                    }, 500);
                });
            }
		},
		mounted(){
            this.getStatsFromLastMonth();
		}
    }
</script>

<style scoped>

</style>
